/**
 * DEC-001: Shopify-style Experience View for Storefront Theme DocType
 * 
 * This view enables Experience mode for Storefront Theme.
 * The actual layout is driven by DocViewSchema (storefrontTheme.ts).
 */

import type { DocTypeView } from '../types';

export const storefrontThemeShopifyView: DocTypeView = {
  id: 'storefront-theme-shopify-v1',
  doctype: 'Storefront Theme',
  style: 'shopify',
  context: undefined,
  status: 'active',
  label: 'Storefront Theme – Shopify Style',
  description: 'Shopify-style layout for Storefront Theme detail page',
  formView: {
    sections: [], // Layout driven by DocViewSchema
    customFieldBucket: {
      enabled: false, // Builder widget handles all fields
    },
  },
  createdBy: 'system',
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
};
